import React from "react";
import { Disclosure } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "react-scroll";

const Navbar = () => {
  const navigation = [
    { name: "Home", href: "/", current: true },
    { name: "About", href: "about", current: false },
    { name: "Experience", href: "experience", current: false },
    { name: "Contact", href: "contact", current: false },
    { name: "Blogs", href: "blog", current: false },
  ];

  return (
    <Disclosure as="nav" className="bg-gray-800  ">
      {({ open }) => (
        <>
          <div className="container mx-auto px-5 ">
            <div className="flex items-center justify-between h-16 px-0 md:px-10">
              <div className="flex items-center">
                <Link to="/">
                  <h1 className="logoText text-white text-3xl">
                    <span className="text-teal-500">R</span>aman.
                  </h1>
                </Link>
              </div>
              <div className="hidden sm:block ">
                <ul className="flex space-x-4">
                  {navigation.map((item, index) => (
                    <li key={index}>
                      <Link
                        to={item.href}
                        smooth
                        duration={500}
                        className="text-gray-300 relative px-3 py-2 text-lg font-medium group transition duration-300 ease-in-out hover:text-white hover:bg-gray-700 cursor-pointer"
                      >
                        {item.name}
                        <span className="absolute left-0 bottom-0 w-full h-0.5 bg-teal-500 transform scale-x-0 group-hover:scale-x-100 transition duration-500"></span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="sm:hidden">
                <Disclosure.Button className="inline-flex items-center justify-center p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="container mx-auto px-4">
              <div className="pt-2 pb-3">
                <ul className="flex flex-col space-y-1">
                  {navigation.map((item, index) => (
                    <li key={index}>
                      <Link
                        to={item.href}
                        className="text-gray-300 px-3 py-2 text-lg font-medium group transition duration-300 ease-in-out hover:text-white hover:bg-gray-700"
                      >
                        {item.name}
                        <span className="absolute left-0 bottom-0 w-full h-0.5 bg-teal-500 transform scale-x-0 group-hover:scale-x-100 transition duration-500"></span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default Navbar;
